import { Environment } from './environment.interface';
import { EnvironmentName } from './EnvironmentName';

export const environment: Environment = {
  production: true,
  name: EnvironmentName.Prod,
  apiUrl: 'https://api.swipes.ch',
  uploadMaxFileSize: 134217728, // 128MB in Bytes
  firebase: {
    apiKey: 'AIzaSyAEFYrx9KVRZCIIITDsmLpS_BKuPRADgaw',
    authDomain: 'app.swipes.ch',
    projectId: 'swipes-app-prod',
    storageBucket: 'swipes-app-prod.appspot.com',
    messagingSenderId: '832465852144',
    appId: '1:832465852144:web:776610062dd8b77a0c9435',
  },
  disableBrandRegistration: false,
  enablePasswordLogin: false,
  sentryDsn: 'https://5b52ac91940922a1df567872469c72ce@o4509163404656640.ingest.de.sentry.io/4509451927355472',
};
